// src/components/probe/ActionButtons.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faShareAlt, faDownload } from '@fortawesome/free-solid-svg-icons';
import logger from '../../utils/logger';

interface ActionButtonsProps {
  onCopy: () => void;
  onShare?: () => void;
  onDownload?: () => void;
  dataToCopy: string; // The actual data to copy
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ onCopy, onShare, onDownload, dataToCopy }) => {

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(dataToCopy);
      logger.info('Content copied to clipboard!');
    } catch (err) {
      logger.error('Failed to copy content: ', err);
    }
    onCopy();
  };

  return (
    <div className="flex space-x-2">
      <button onClick={handleCopy} className="icon-button" title="Copy to clipboard"><FontAwesomeIcon icon={faCopy} /></button> 
      {onShare && (<button onClick={onShare} className="icon-button" title="Share"><FontAwesomeIcon icon={faShareAlt} /></button>)}
      {onDownload && (<button onClick={onDownload} className="icon-button" title="Download"><FontAwesomeIcon icon={faDownload} /></button>)}
    </div>
  );
};

export default ActionButtons;